document.addEventListener('dkLabFavouriteProductsLoaded', function (event) {
    $(".product").each(function(){
        $(this).find(".dkLabFavouriteProductDiv").appendTo($(this).find(".p"));
    })
});

document.addEventListener('ShoptetDOMContentLoaded', function (event) {
    $(".product").each(function(){
        $(this).find(".dkLabFavouriteProductDiv").appendTo($(this).find(".p"));
    })
});
